/* eslint-disable unused-imports/no-unused-imports */
import { Hidden, Stack } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from 'react';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

import ScrollTop from '@components/buttons/ScrollTop';
import { Helmet } from 'react-helmet-async';
import Banner from './Banner';
import Mission from './Mission';
import Result from './Result';
// eslint-disable-next-line unused-imports/no-unused-imports
import News from './Media';
import QuickActions from './Carreer';
import Together from './Together';
// import Timeline from './Timeline';
import Skill from './Skill';

import TimelineMobile from './Timeline/Mobile';

import SmoothScroll from './Timeline';

// Loading fallback component

const FlagshopPage = () => {
  AOS.init({
    startEvent: 'load'
  });

  useEffect(() => {
    window.scrollTo({
      top: 0
    });

    // Add resize handler to refresh ScrollTrigger
    const handleResize = () => {
      ScrollTrigger.getAll().forEach((st) => st.refresh());
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      // Kill all ScrollTriggers on unmount
      ScrollTrigger.getAll().forEach((st) => st.kill());
    };
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.workershigh.com"
          data-rh="true"
        />
        <meta
          property="og:url"
          content="https://www.workershigh.com"
          data-rh="true"
        />
        <meta name="description" content="공간 리테일 서비스의 모든 것" />
        <title>워커스하이</title>
      </Helmet>
      <Stack
        sx={{
          backgroundColor: '#FFFFFF',
          overflowX: 'clip'
        }}
      >
        <Banner />
        <Mission />
        <Skill />
        <Result />
        <Stack sx={{ display: { md: 'flex', xs: 'none' } }}>
          <SmoothScroll />
        </Stack>

        <Stack sx={{ display: { md: 'none', xs: 'flex' } }}>
          <TimelineMobile />
        </Stack>

        <Together />
        <News />
        <QuickActions />
        <ScrollTop />
      </Stack>
    </>
  );
};

export default FlagshopPage;
